<template>
  <div role="tablist" class="tabs tabs-border mb-2">
    <button
      role="tab"
      class="tab"
      :class="{ 'tab-active': modelValue === 'topo' }"
      @click="emit('update:modelValue', 'topo')"
    >
      <i class="fa-solid fa-diagram-project mr-2"></i>
      Topology Mạng
    </button>
    <button
      role="tab"
      class="tab"
      :class="{ 'tab-active': modelValue === 'log' }"
      @click="emit('update:modelValue', 'log')"
    >
      <i class="fa-solid fa-terminal mr-2"></i>
      Nhật ký quét
    </button>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: "NetworkScanTabs" });

// Presentational tab strip only: no route/store access, so it renders in
// Storybook and SSR without the app router.
defineProps<{ modelValue: "topo" | "log" }>();
const emit = defineEmits<{ "update:modelValue": ["topo" | "log"] }>();
</script>
